<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="dominio in dominios" :key="dominio._id">
          <td>{{ dominio.nome }}</td>
          <td>{{ dominio.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              id="botaoEditar"
              v-tooltip="'Editar'"
              data-test-id="link-botaoeditar"
              :to="'/dominio/cadastro/' + dominio._id"
              name="botaoEditar"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'

export default {
  mixins: [alertaMixin],
  props: {
    dominios: {
      type: Array,
      required: true,
    },
  },
}
</script>
